<template>
  <div class="tutorial">
    <h3>🎓 Game Explanation</h3>
    <ul>
      <li><strong>Classic Mode:</strong> Traditional Go Rules</li>
      <li><strong>Superposition:</strong> Stones can exist in multiple positions simultaneously, collapsing upon measurement</li>
      <li><strong>Entanglement:</strong> Two stones' states are mutually related, measuring one affects the other</li>
      <li><strong>Measurement:</strong> Collapses superposition states into definite states</li>
      <li><strong>Hadamard Gate (H):</strong> Creates superposition states</li>
      <li><strong>CNOT Gate:</strong> Creates entangled states between two stones</li>
      <li><strong>Pauli-X/Z Gates:</strong> Flip stone color/phase</li>
      <li><strong>Quantum Tunneling:</strong> Stones have a probability of passing through the board</li>
      <li><strong>Quantum Teleportation:</strong> Transport using entanglement</li>
      <li><strong>Bell State Measurement:</strong> Measure entangled pairs, revealing quantum correlations</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Tutorial'
};
</script>

<style scoped>
.tutorial {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  margin-top: 15px;
}
.tutorial h3 {
  color: #667eea;
  margin-bottom: 15px;
}
.tutorial ul {
  list-style: none;
  padding: 0;
}
.tutorial li {
  padding: 10px;
  margin: 8px 0;
  background: white;
  border-radius: 5px;
  border-left: 4px solid #667eea;
  font-size: 0.95em;
}
.tutorial strong {
  color: #764ba2;
}
</style>